import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { Divider, Header } from 'semantic-ui-react'
import config from 'config/config'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.navigation
  const { currentUser } = state.user
  return { currentUser, language }
}

class Greeting extends React.PureComponent {
  render() {
    const now = new Date()
    const hour = now.getHours()

    const { currentUser } = this.props

    let key = 'afternoon'

    if (hour > 5 && hour <= 11) key = 'morning'
    if (hour > 11 && hour <= 13) key = 'lunch'
    if (hour > 13 && hour <= 19) key = 'afternoon'
    if (hour > 19 && hour < 23) key = 'evening'
    if (hour >= 23 || hour <= 5) key = 'late'

    return (
      <div className="Greeting noselect">
        <Divider clearing hidden className="compact" />
        <Header
          as="h1"
          inverted
          content={I18n.t(`admin.dashboard.greeting.${key}`, {
            user: currentUser.name,
          })}
        />
        <Header as="h2" inverted content={I18n.t('admin.dashboard.subtitle')} />
        {key === 'late' && (
          <p children={I18n.t('admin.dashboard.greeting.late_advise')} />
        )}
        <Divider hidden className="compact" />
        <Header as="h6" inverted>
          <div style={{ float: 'left', marginRight: '2em' }}>
            {config.version}
          </div>
        </Header>
        <Divider clearing hidden className="compact" />
      </div>
    )
  }
}

Greeting = connect(mapStateToProps)(Greeting)
export default Greeting



// WEBPACK FOOTER //
// ./src/components/admin/Helper/Greeting.jsx